import React, { useState } from "react";
import ModalMessage from "./ModalMessage";

/**
 * Delete button with built-in "confirm" / "cannot delete" modals.
 * Keeps modal state inside the component, so parent doesn't need extra useState.
 */
const DeleteDecoderButton = ({
  canDelete,
  onConfirmDelete,
  confirmTitle = "Submit the action",
  confirmMessage = "Are you sure with it?",
  blockedTitle = "Error",
  blockedMessage = "You have already paid for this decoder. It can be deleted only after the subscription has expired.",
  buttonLabel = "Delete",
}) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [showBlocked, setShowBlocked] = useState(false);

  const open = () => {
    window.scrollTo({ top: 0 });
    if (canDelete) setShowConfirm(true);
    else setShowBlocked(true);
  };

  return (
    <>
      <button onClick={open}>{buttonLabel}</button>

      {showConfirm && (
        <ModalMessage
          title={confirmTitle}
          message={confirmMessage}
          actions={
            <>
              <button
                className="error-btn"
                onClick={() => {
                  onConfirmDelete?.();
                  setShowConfirm(false);
                }}
              >
                Ok
              </button>
              <button className="error-btn" onClick={() => setShowConfirm(false)}>
                Cancel
              </button>
            </>
          }
        />
      )}

      {showBlocked && (
        <ModalMessage
          title={blockedTitle}
          message={blockedMessage}
          actions={<button className="error-btn" onClick={() => setShowBlocked(false)}>Ok</button>}
        />
      )}
    </>
  );
};

export default DeleteDecoderButton;

